import {
    RiBarChartBoxLine,
    RiCodeSSlashLine,
    RiCoinLine, RiDatabase2Line, RiExchangeFundsLine,
    RiGeminiLine,
    RiLeafLine,
    RiNavigationLine, RiNodeTree, RiPlantLine,
    RiRocketLine,
    RiSafeLine,
    RiSpeakLine,
    RiWallet3Line,
    RiFileSearchLine,
    RiArrowLeftRightLine,
    RiImageLine,
    RiShoppingCartLine,
    RiHandHeartLine,
    RiGovernmentLine,
} from "@remixicon/react";

export const mainConfig = {
    title: "Larissa Portal",
    description: "Larissa Portal",
    menu: [
        {
            title: "Blockchain",
            items: [
                {
                    title: "Stats",
                    url: "/blockchain/stats",
                    icon: RiNavigationLine,
                    isActive: false,
                },
                {
                    title: "Wallet",
                    url: "/blockchain/wallet",
                    icon: RiWallet3Line,
                },
                {
                    title: "Buy $LRS",
                    url: "/blockchain/buy",
                    icon: RiCoinLine,
                },
                {
                    title: "Donation",
                    url: "/donation",
                    icon: RiHandHeartLine,
                },
                {
                    title: "Larissa DAO",
                    url: "/larissa-dao",
                    icon: RiGovernmentLine,
                },
                {
                    title: "Showcase",
                    url: "/blockchain/showcase",
                    icon: RiGeminiLine,
                },
                {
                    title: "Ecosystem",
                    url: "/blockchain/ecosystem",
                    icon: RiLeafLine,
                },
                {
                    title: "Emission",
                    url: "/blockchain/emission",
                    icon: RiSpeakLine,
                },
                // {
                //   title: "Swap",
                //   url: "/blockchain/swap",
                //   icon: RiExchangeLine,
                // },
                {
                    title: "Staking",
                    url: "/blockchain/staking",
                    icon: RiSafeLine,
                },
                {
                    title: "Farming",
                    url: "/blockchain/farming",
                    icon: RiPlantLine,
                },
            ],
        },
        {
            title: "BRIDGE",
            items: [
                {
                    title: "Bridge",
                    url: "/blockchain/bridge",
                    icon: RiExchangeFundsLine,
                },
                {
                    title: "Bridge Stats",
                    url: "/blockchain/bridge-stats",
                    icon: RiNavigationLine,
                },
                {
                    title: "Bridge Scan",
                    url: "/blockchain/bridge-scan",
                    icon: RiFileSearchLine,
                },
            ],
        },
        {
            title: "MIGRATION",
            items: [
                {
                    title: "LRSNode",
                    url: "/blockchain/migration/lrsn",
                    icon: RiArrowLeftRightLine,
                },
                {
                    title: "Silo",
                    url: "/blockchain/migration/silo",
                    icon: RiArrowLeftRightLine,
                },
            ],
        },
        {
            title: "SILO",
            items: [
                {
                    title: "Individual",
                    url: "/silo/individual",
                    icon: RiCodeSSlashLine,
                },
                {
                    title: "Enterprise",
                    url: "/silo/enterprise",
                    icon: RiDatabase2Line,
                },
                {
                    title: "Nodes",
                    url: "/silo/nodes",
                    icon: RiNodeTree,
                },
                {
                    title: "Setup New Node",
                    url: "/silo/setup-node",
                    icon: RiRocketLine,
                },
                {
                    title: "Reward Calculator",
                    url: "/silo/reward-calculator",
                    icon: RiBarChartBoxLine,
                },
            ],
        },
        {
            title: "LRSNode",
            items: [
                {
                    title: "My Nodes V2",
                    url: "/lrsnode/mynodes",
                    icon: RiNodeTree,
                },
                {
                    title: "My Nodes V3",
                    url: "/lrsnode/mynodes-v3",
                    icon: RiNodeTree,
                },
                {
                    title: "Reward Calculator",
                    url: "/lrsnode/reward-calculator",
                    icon: RiCoinLine,
                },
            ],
        },
        {
            title: "NFTs",
            items: [
                // {
                //     title: "NFT V1",
                //     url: "/nfts/v1",
                //     icon: RiImageLine,
                // },
                {
                    title: "NFT V2",
                    url: "/nfts/v2",
                    icon: RiImageLine,
                },
                // {
                //     title: "NFT Marketplace",
                //     url: "/nfts/marketplace",
                //     icon: RiShoppingCartLine,
                // },
            ],
        },
    ],
    countryCodeToName: {
        "CA": "Canada",
        "DE": "Germany",
        "ES": "Spain",
        "IN": "India",
        "NL": "Netherlands",
        "RU": "Russia",
        "US": "United States",
        "GB": "United Kingdom",
        "CN": "China",
        "BR": "Brazil",
        "FR": "France",
        "IT": "Italy",
        "JP": "Japan",
        "KR": "South Korea",
        "MX": "Mexico",
        "TR": "Turkey",
        "VN": "Vietnam",
    } as Record<string, string>,
    rewardSystem: {
        blocksPerYear: 2628000,
        newRewardApplyBlock: 639675,
        newStakeRewardApplyBlock: 1952106,
        reductionInterval: 46523,
        reductionFactor: 0.9938,
        weeksPerYear: 52,
        initialReward: 5,
    },
    wallets: {
        android: "https://play.google.com/store/apps/details?id=network.larissa.wallet&pli=1",
        ios: "https://apps.apple.com/app/larissa-wallet/id6480113884",
        windows: "https://larissa.network/custom/softwares/walletWindows/1.0.4+4/larissa_wallet_desktop-1.0.4+4-windows-setup.exe",
        telegram: "https://t.me/LarissaWalletBot",
    },
    otherLinks: {
        nftMarketplace: "https://nft.larissa.network/",
        casinoGame: "https://crypto-casino.larissa.network/",
        siloPhotos: "https://play.google.com/store/apps/details?id=com.silos3.photos",
        siloDrive: "https://play.google.com/store/apps/details?id=com.silos3.drive",
        vibeo: "https://play.google.com/store/apps/details?id=com.reel.vibeo&hl=en",
        kyklos: "https://kyklos.network/",
        optilics: "https://optilics.com/",
    },
    chainHexID: "0x26AA", // 9898 in hex
    siloPlans: [
        { name: "Starter", storage: "10 GB", monthlyPrice: "$0.00", yearlyPrice: "$0.00" },
        { name: "Essential", storage: "60 GB", monthlyPrice: "$0.35", yearlyPrice: "$10.91" },
        { name: "Pro", storage: "100 GB", monthlyPrice: "$0.41", yearlyPrice: "$11.62" },
        { name: "Advanced", storage: "200 GB", monthlyPrice: "$0.60", yearlyPrice: "$18.59" },
        { name: "Plus", storage: "2000 GB", monthlyPrice: "$1.88", yearlyPrice: "$60.45" },
        { name: "Elite", storage: "5000 GB", monthlyPrice: "$4.71", yearlyPrice: "$151.14" },
        { name: "Premium", storage: "10000 GB", monthlyPrice: "$9.42", yearlyPrice: "$302.28" },
    ],
    siloPricing: [
        {
            type: "Object Storage",
            units: "Bytes",
            increment: "GB Hour",
            pricingUnit: "GB Month",
            price: "$0.0036 per GB Month",
            description: "Storage is calculated based on bytes uploaded, including any encryption-based overhead"
        },
        {
            type: "Egress Bandwidth",
            units: "Bytes",
            increment: "GB",
            pricingUnit: "Total Volume",
            price: "$0.0063 per GB",
            description: "Bandwidth related to object downloads calculated on bytes downloaded including long tail elimination-related bandwidth"
        },
        {
            type: "Segments",
            units: "Segments",
            increment: "Segment Hour",
            pricingUnit: "Segment Month",
            price: "$0.0000079 per Segment Month",
            description: "Segments usage depends on storage. The default size for a segment is 64MB (or less), i.e., smaller objects use more segments"
        }
    ],
    siloProducts: {
        individual: [
            {
                name: "SILODrive",
                description: "Decentralized cloud storage with advanced encryption for secure file management. Access, store, and share files globally, ensuring privacy and data control beyond traditional storage providers.",
                image: "/images/logos/sDrive.png",
                status: "Available",
                links: [
                    { platform: "Google Play", url: "https://play.google.com/store/apps/details?id=com.silos3.drive" },
                    { platform: "iOS", url: "#", status: "Under Development" }
                ]
            },
            {
                name: "SILOPhotos",
                description: "Store, organize, and share your photos privately with SPhotos. Secure, encrypted, and decentralized photo storage for complete control over your memories, accessible from anywhere.",
                image: "/images/logos/sPhoto.png",
                status: "Available",
                links: [
                    { platform: "Google Play", url: "https://play.google.com/store/apps/details?id=com.silos3.photos" },
                    { platform: "iOS", url: "#", status: "Under Development" }
                ]
            },
            {
                name: "SILO Mail",
                description: "Privacy-focused decentralized email service, protecting your communications from third-party access. Experience secure, encrypted emails with SILO Mail for personal or enterprise use.",
                image: "/images/logos/sMail.png",
                status: "Coming Soon",
                links: []
            },
            {
                name: "SILO Messenger",
                description: "Secure, encrypted messaging designed for private communication. SILO Messenger provides a decentralized platform where your chats remain confidential, keeping your conversations private and safe.",
                image: "/images/logos/sMsg.png",
                status: "Coming Soon",
                links: []
            },
            {
                name: "SILO AI",
                description: "Intelligent AI-powered assistant that optimizes workflows and personalizes data processing. SILO AI enhances productivity by offering custom insights for both personal and enterprise users.",
                image: "/images/logos/SiloAi.png",
                status: "Coming Soon",
                links: []
            }
        ],
        enterprise: [
            {
                name: "SConnect",
                description: "An S3-compatible library for seamless integration with SILO's distributed storage. SConnect empowers enterprises with secure, decentralized data solutions that adapt to existing applications.",
                image: "/images/logos/sConnect.png",
                status: "Coming Soon",
                links: []
            },
            {
                name: "SILO Ads Server",
                description: "Decentralized advertising server ensuring user privacy while monetizing through targeted, secure ads. SILO Ads Server empowers brands with direct, privacy-respecting audience reach.",
                image: "/images/logos/sAdServer.png",
                status: "Coming Soon",
                links: []
            },
            {
                name: "Distributed Computing",
                description: "Decentralized computing platform utilizing distributed resources for enterprise scalability. SILO's Distributed Computing offers efficient, secure computational power across a resilient network.",
                image: "/images/logos/Distributed.png",
                status: "Coming Soon",
                links: []
            },
            {
                name: "SILO Mail (Enterprise)",
                description: "Privacy-focused decentralized email service, protecting your communications from third-party access. Experience secure, encrypted emails with SILO Mail for personal or enterprise use.",
                image: "/images/logos/sMail.png",
                status: "Coming Soon",
                links: []
            },
            {
                name: "SILO Communication",
                description: "Comprehensive team collaboration tool for secure workspace chat, file sharing, and video conferencing. SILO Communication integrates with apps to enhance teamwork in a decentralized environment.",
                image: "/images/logos/sMsg.png",
                status: "Coming Soon",
                links: []
            },
            {
                name: "SILO AI (Enterprise)",
                description: "Intelligent AI-powered assistant that optimizes workflows and personalizes data processing. SILO AI enhances productivity by offering custom insights for both personal and enterprise users.",
                image: "/images/logos/SiloAi.png",
                status: "Coming Soon",
                links: []
            }
        ],
    },
    daoWallets: [
        {
            name: "LRSNODE DAO (Node Rewards)",
            address: "0xD19a06CBCDb96d4f499990391f2f1ED04F6655A6",
            allocation: 50,
            description: "Will be locked in LRSNode DAO Contract",
            label: "NodeRewardHolder"
        },
        {
            name: "Mining contract",
            address: "0xbEA16d79469d68a260EC528Bf7CE1c4899cEf267",
            allocation: 30,
            description: "Will be locked on Mining Contract",
            label: "MiningRewardHolder"
        },
        {
            name: "Team and advisors",
            address: "0xb123d7EF2B27f6CB5a4Ebf74D8Cf478d39032875",
            allocation: 10,
            description: "Will be locked for first 6 months, after 6 months 10% will be released every month",
            label: "TeamTokenLocker"
        },
        {
            name: "Marketing and community development",
            address: "0x2416aE486252E8b784847B66cDf4dfdC8F240d85",
            allocation: 5,
            description: "",
            label: "LRSN Marketing"
        },
        {
            name: "Airdrops",
            address: "0x1a0bB88880C7Fc1164d15214F49344a88572FeB0",
            allocation: 2,
            description: "",
            label: "AirdropFundHolder"
        },
        {
            name: "LRSN staking rewards",
            address: "0x38bDe90348de44E5a25B6DC2d70D425c3621ad0f",
            allocation: 3,
            description: "",
            label: "StakingFundHolder"
        }
    ],
};
